import React from "react";
import AntSelect, { SelectProps, SelectValue } from "antd/lib/select";

import "./select.less";

export const Select = <T extends SelectValue>(props: SelectProps<T>) => <AntSelect<T> {...props} />;
export const { Option } = AntSelect;
export type { SelectProps, SelectValue } from "antd/lib/select";
